module.exports = __webpack_public_path__ + "img/aerofilms.e63655cb.png";